import { Bell, Search, Sun, Moon, Menu } from 'lucide-react'
import { useTheme } from '@/contexts/theme-context'

interface MentorHeaderProps {
    showMenuButton?: boolean
    onMenuClick?: () => void
}

export function MentorHeader({ showMenuButton = true, onMenuClick }: MentorHeaderProps) {
    const { theme, toggleTheme } = useTheme()

    return (
        <div className="flex items-center justify-between gap-3">
            {/* Mobile Menu Button */}
            {showMenuButton && (
                <button
                    onClick={onMenuClick}
                    className="lg:hidden p-2 -ml-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-theme-secondary"
                >
                    <Menu className="h-6 w-6" />
                </button>
            )}

            <div className="flex-1 max-w-xl">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-theme-secondary" />
                    <input
                        type="text"
                        placeholder="Search students, tasks..."
                        className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 border border-transparent focus:border-primary-blue focus:bg-white dark:focus:bg-slate-900 text-theme-primary placeholder:text-theme-secondary transition-all outline-none"
                    />
                </div>
            </div>

            <div className="flex items-center gap-3">
                {/* Theme Toggle */}
                <button
                    onClick={toggleTheme}
                    className="p-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors text-theme-secondary hover:text-theme-primary"
                >
                    {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
                </button>

                {/* Notifications */}
                <button className="relative p-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors">
                    <Bell className="h-5 w-5 text-theme-secondary" />
                    <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
                </button>

                {/* Mentor Profile */}
                <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-100 dark:bg-slate-800">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-white font-bold text-sm">
                        DS
                    </div>
                    <div className="hidden md:block">
                        <p className="text-sm font-semibold text-theme-primary">Dr. Sarah</p>
                        <p className="text-xs text-theme-secondary">Mentor</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
